<template>
  <div>
    <loading v-show="load" :fullscrean="true" text="Carregando as informações"/>
  </div>
</template>

<script>
  import AdsLeCard from "../../../components/AdsLeCard";
  import Loading from '../../../components/Loading'

  export default {
    name: 'Pedidos',
    components: {AdsLeCard, Loading},
    data() {
      return {
        load: false
      }
    },

    created() {
      window.location.href = "https://www.lecard.delivery";
    },
  }
</script>
<style scoped>
</style>
